var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xzj-wrapper"},[_c('img',{attrs:{"src":require("@/assets/images/xzj-xcb-banner.jpg"),"alt":""}}),_c('a',{staticClass:"go-back s-activity-back",attrs:{"href":"javascript:;"},on:{"click":function (e){ return this$1.$router.back(); }}})])}
var staticRenderFns = []

export { render, staticRenderFns }